
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { API_URL } from "config";
import useContents, { TContents } from "customHooks/useContents";
import useHeaderTitleSetter from "customHooks/useHeaderTitleSetter";
import useMobile from "customHooks/useMobile";
import AboutLayout from "layout/AboutLayout";
import { GetStaticPaths } from "next";
import { useRouter } from "next/router";
import { getStaticPagesLayoutData } from "ssrUtils";
import { AboutLayoutProps } from ".";
import AnnualReports from "components/AnnualReports/AnnualReports";
const Slug: React.FC<AboutLayoutProps> = () => {
    const { locale, query } = useRouter();
    const { data: conts } = useContents();
    const about = conts?.pages?.find((page) => page.slug === query.slug)?.contents;
    const aboutBody = about?.body?.[locale];
    const title = about?.title?.[locale];
    useHeaderTitleSetter({ title, section: "" });
    const isMobile = useMobile("md");
    if (query["slug"] === "reports") {
        return <AnnualReports />;
    }
    return (<div className={isMobile ? "container px-4 mt-3" : ""}>
      <div className="mt-4 about-child" dangerouslySetInnerHTML={{ __html: aboutBody }}/>
    </div>);
};
export default Slug;
(Slug as any).Layout = AboutLayout;
const getStaticProps = getStaticPagesLayoutData;
export const getStaticPaths: GetStaticPaths<{
    slug: string;
}> = async ({ locales, }) => {
    const filteredLocales = locales?.filter((locale) => locale !== "default");
    const conts = await fetch(API_URL + "/contents");
    const data = (await conts.json()) as TContents;
    const paths = data?.pages
        ?.map((page) => {
        return filteredLocales.map((locale) => ({
            params: {
                slug: page.slug
            },
            locale
        }));
    })
        .flat();
    const annualPaths = filteredLocales
        .map((locale) => ({
        params: {
            slug: "reports"
        },
        locale
    }))
        .flat();
    const pathsWithAnnual = [...paths, ...annualPaths];
    return {
        paths: pathsWithAnnual,
        fallback: false
    };
};

    async function __Next_Translate__getStaticProps__197cac821e3__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197cac821e3__ as getStaticProps }
  